import { config } from 'component/Search/Datepicker/__config';
import { FormType } from 'component/Search/Datepicker/types';

import addDays from 'date-fns/addDays';
import format from 'date-fns/format';

const baseDate = new Date();

const generateTravelDate = (
    date: Date
): { value: string; description: string } => {
    const formattedDate = format(date, config.format);
    return {
        value: formattedDate,
        description: formattedDate.slice(0, 6), //This cuts off the year and keeps only the day and month.
    };
};

export const travelDateList = {
    [FormType.Package]: {
        departureDate: generateTravelDate(addDays(baseDate, 1)),
        returnDate: generateTravelDate(addDays(baseDate, 15)),
    },
    [FormType.LastMinute]: {
        departureDate: generateTravelDate(addDays(baseDate, 1)),
        returnDate: generateTravelDate(addDays(baseDate, 57)),
    },
    [FormType.EarlyBird]: {
        departureDate: generateTravelDate(addDays(baseDate, 174)),
        returnDate: generateTravelDate(addDays(baseDate, 197)),
    },
    [FormType.AllInclusive]: {
        departureDate: generateTravelDate(addDays(baseDate, 1)),
        returnDate: generateTravelDate(addDays(baseDate, 15)),
    },
};
